import type { ReactNode } from 'react';
import type { IptvSource } from '../api.js';
import { RefreshIcon, TrashIcon } from '../Icon.tsx';

/**
 * Canlı TV kaynaklarının yönetim listesi.
 *
 * Kullanıcının eklediği M3U ve Xtream çalma listelerini listeler;
 * her kaynak için yenileme ve silme eylemleri sunar.
 */
export function LiveTvSources({
  sources,
  busy,
  onRefresh,
  onRemove,
}: {
  sources: IptvSource[];
  busy: boolean;
  onRefresh: (id: string) => void;
  onRemove: (id: string, name: string) => void;
}): ReactNode {
  if (sources.length === 0) return null;

  return (
    <div className="live-tv__sources">
      <div className="live-tv__header-left">
        <h2 className="live-tv__subtitle">Ekli Kaynaklar ({sources.length})</h2>
      </div>
      <ul className="live-tv__source-list">
        {sources.map((source) => (
          <li key={source.id} className="live-tv__source">
            <span className="live-tv__source-body">
              <span className="live-tv__source-title-row">
                <span className="live-tv__source-name">{source.name}</span>
                <span className="live-tv__source-type-pill">{source.kind.toUpperCase()}</span>
              </span>
              <span className="live-tv__source-meta">
                <span
                  className={`live-tv__source-status-dot${
                    source.lastError !== null ? ' live-tv__source-status-dot--error' : ''
                  }`}
                  aria-hidden="true"
                />
                <span>{source.channelCount} kanal</span>
                {source.lastError !== null && (
                  <span style={{ color: 'var(--danger)' }}>· Son eşitleme hatası</span>
                )}
              </span>
            </span>
            <div className="live-tv__source-actions">
              <button
                type="button"
                className="live-tv__source-action"
                onClick={() => onRefresh(source.id)}
                disabled={busy}
                title="Kaynak kanal listesini yenile"
              >
                <RefreshIcon size={14} />
                <span>Yenile</span>
              </button>
              <button
                type="button"
                className="live-tv__source-action live-tv__source-action--danger"
                onClick={() => onRemove(source.id, source.name)}
                disabled={busy}
                title="Kaynağı ve kanallarını sil"
              >
                <TrashIcon size={14} />
                <span>Sil</span>
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
